export default __webpack_public_path__ + "static/media/hero-img.4ad0b49a.png";